import type { LevelDef } from './core/level';

/** All level files (levels/level-NNN.json), bundled into the game at build time. */
const files = import.meta.glob('../levels/level-*.json', { eager: true, import: 'default' }) as Record<string, LevelDef>;

export const LEVELS: LevelDef[] = Object.values(files).sort((a, b) => a.id - b.id);

export function getLevel(id: number): LevelDef | undefined {
  return LEVELS.find((l) => l.id === id);
}

const CUSTOM_KEY = 'cafe-paws.customLevel';

/** A level handed over from the web editor ("Play" button). */
export function loadCustomLevel(): LevelDef | undefined {
  try {
    const raw = localStorage.getItem(CUSTOM_KEY);
    return raw ? (JSON.parse(raw) as LevelDef) : undefined;
  } catch {
    return undefined;
  }
}

export function saveCustomLevel(def: LevelDef): boolean {
  try {
    localStorage.setItem(CUSTOM_KEY, JSON.stringify(def));
    return true;
  } catch {
    return false;
  }
}
